<!-- /用户端聊天界面 -->


<template>
	<div class="chat-container" ref="chatContainer" @mousedown="startDrag" @mousemove="onDrag" @mouseup="stopDrag"
		@mouseleave="stopDrag">
		<div class="biaoqing" v-if="isbq">
			<span v-for="(item,index) in emotions" @click="jionbq(item)">{{item}}</span>
		</div>
		<div class="close" @click="runclose()">
			<span>×</span>
		</div>


		<!-- 头部信息区域 -->
		<div class="chat-header">
			<div class="avatar-container">
				<div class="xiangs">
					{{target.toname[0]}}
				</div>
				<span class="online-indicator" :class="{online: isOnline=='在线'}"></span>
			</div>
			<div class="user-info">
				<h3 class="user-name">{{target.toname }}</h3>
				<p class="online-status">{{ isOnline }}</p>
			</div>
		</div>
		<!-- 聊天消息区域：添加 ref 用于滚动操作 -->
		<div class="chat-messages" ref="chatMessagesRef" @click="isdel=-1">
			<div v-for="(msg, index) in messages" :key="index">
				<!-- 时间线 -->
				<div v-if="shouldShowTimeline(index)" class="timeline">
					{{ formatTimeline(msg.type.Date) }}
				</div>

				<!-- 消息气泡 -->
				<div class="message" :class="{
      left: msg.isOther, 
      right: !msg.isOther, 
      'no-bubble': ['image', 'file'].includes(msg.type.type)
    }" @contextmenu.prevent="isdel=index">

					<div class="avatar">
						<div class="xiang" :class="{'xiang1':msg.isOther}">
							{{msg.isOther?target.toname[0]:'我'}}
						</div>
					</div>

					<div class="content" :class="msg.type.type">
						<!-- 文本消息 -->
						<template v-if="msg.type.type === 'text'">
							<div class="bubble">{{ msg.msg }}</div>
						</template>

						<!-- 图片消息 -->
						<template v-if="msg.type.type === 'image'">
							<img :src="msg.msg.url" class="message-image" alt="图片" @click="previewImage(msg.msg.url)">
						</template>
						<template v-if="msg.type.type === 'public'">
							<div class="announcement-card" @click="toggleAnnouncement(index)">
								<div class="announcement-header">
									<div class="announcement-icon">📢<span>[公告] {{msg.msg.title}}</span></div>
									<!-- <div class="announcement-title"></div> -->
									<div class="announcement-arrow">
										{{ expandedAnnouncements[index] ? '▲' : '▼' }}
									</div>
								</div>
								<div class="announcement-content" :class="{expanded: expandedAnnouncements[index]}">
									<div class="announcement-text">{{msg.msg.content}}</div>
									<div class="announcement-time">{{ formatAnnouncementTime(msg.type.Date) }}
									</div>
								</div>
							</div>
						</template>

						<!-- 文件消息 -->
						<template v-if="msg.type.type === 'file'">
							<div class="file-item" @click="downloadFile(msg.msg.url, msg.msg.name)">
								<div class="file-info">
									<div class="file-name">{{ msg.msg.name}}</div>
									<div class="file-size">{{townum(msg.msg.size)}}</div>
								</div>
							</div>
						</template>
					</div>

					<div class="avatar1" v-if="isdel==index" @click="Sdelmsg(index)">
						<div class="del-msg">×</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 输入区域 -->
		<div class="input-area">
			<!-- 功能按钮区：文件按钮绑定点击事件 -->
			<div class="function-buttons">
				<img src="../../assets/表情.png" class="Simg" @click="isbq=!isbq" alt="表情">
				<img src="../../assets/文件.png" class="Simg1" @click="triggerFileSelect" alt="选择文件">

				<input type="file" class="hidden-file-input" ref="fileInputRef" @change="handleFileSelect" accept="*" />
				<span class="alldel">
					<el-button type="warning" size="mini" @click="Sdelall()">清空全部消息</el-button>
				</span>

			</div>

			<!-- 输入框和发送按钮 -->
			<div class="text-input-container">
				<textarea v-model="inputMessage" placeholder="输入消息..." @focus="switchToText" class="text-input"
					@keydown.enter.prevent="sendCurrentContent(inputMessage,'text')" /></textarea>
			</div>
		</div>
		<button class="send-btn" @click="sendCurrentContent(inputMessage,'text')"
			:disabled="!inputMessage.trim()">发送</button>

		<!-- 图片预览弹窗：默认隐藏 -->
		<div class="image-preview" v-if="previewImageUrl" @click="closePreview">
			<img :src="previewImageUrl" alt="图片预览">
		</div>
	</div>
</template>

<script>
	import {
		Getitem,
		Setitem
	} from "@/utils/item";
	import {
		sendWebSocketMessage,

	} from "@/utils/websocketMessageHandler.js";
	import {
		uploadFile
	} from "@/utils/request.js";

	export default {
		props: {
			target: {
				type: Object,
				required: true, // 强制要求传入 target 属性
				default: () => ({})
			}
		},
		data() {
			return {
				ws: null,
				myclass: 'cus',
				messages: [],
				inputMessage: '',
				selectedFile: null, // 存储选中的文件
				isRecording: false,
				recordedAudio: null,
				msgmenname: '',
				emotions: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍',
					'🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐',
					'🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒',
					'🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '😕', '😟',
					'🙁', '☹️', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖',
					'😣', '😞', '😓', '😩', '😫', '😤', '😡', '😠', '🤬', '😈', '👿', '💀', '☠️', '💩', '🤡', '👹',
					'👺', '👻', '👽', '👾', '🤖', '😂', '😍', '👍', '👋', '🙏', '🎉', '❤️', '😊', '🤔', '😎', '🥳',
					'🤗', '😘', '🤣', '🥰', '👏', '🤔', '😜', '🤓', '🤯', '😱', '🤧', '🥵', '🤮', '🤢', '🥴', '🤠',
					'👻', '💀', '👾', '🤖', '👽', '🎃', '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯',
					'🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺',
					'🐗', '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐚', '🐞', '🐜', '🦟', '🦗', '🕷️', '🕸️', '🦂', '🐢',
					'🐍', '🦎', '🦖', '🦕', '🐙', '🦑', '🦐', '🦀', '🐡'
				],
				myAvatar: 'https://picsum.photos/id/1005/200',
				otherAvatar: 'https://picsum.photos/id/1012/200',
				isbq: false,
				isOnline: this.$store.state.otherline,
				previewImageUrl: '', // 图片预览地址
				activePanel: null, // 修复未定义的变量
				isdel: -1,
				tokenname: this.$store.state.tokenName,
				isgd: false,
				onlineStatus: {
					s1: false,
					s2: false
				},
				myTimer: null, // 存储定时器 ID（关键：初始为 null）
				isDragging: false,
				dragOffsetX: 0,
				dragOffsetY: 0,
				containerPosition: {
					x: 0,
					y: 0
				},
				expandedAnnouncements: {},


			};
		},
		methods: {
			toggleAnnouncement(index) {
				this.$set(this.expandedAnnouncements, index, !this.expandedAnnouncements[index]);
				this.$nextTick(() => {
					this.scrollToBottom();

				});

			},
			formatAnnouncementTime(ts) {
				const time = new Date(parseInt(ts));
				const now = new Date();
				const diff = now - time;

				// 1分钟内显示"刚刚"
				if (diff < 60000) {
					return '刚刚';
				}
				// 1小时内显示分钟
				if (diff < 3600000) {
					return `${Math.floor(diff / 60000)}分钟前`;
				}
				// 1天内显示小时
				if (diff < 86400000) {
					return `${Math.floor(diff / 3600000)}小时前`;
				}
				// 其他情况显示完整时间
				return `${time.getMonth() + 1}月${time.getDate()}日 ${time.getHours().toString().padStart(2, "0")}:${time.getMinutes().toString().padStart(2, "0")}`;
			},
			startDrag(e) {
				// 仅允许点击头部区域拖拽（精准控制触发范围）
				if (!e.target.closest('.chat-header')) return;

				this.isDragging = true;
				// 关键：记录「鼠标当前位置」与「容器当前定位」的差值（固定偏移量）
				this.dragOffsetX = e.clientX - this.containerPosition.x;
				this.dragOffsetY = e.clientY - this.containerPosition.y;
				// 拖拽样式
				this.$refs.chatContainer.style.cursor = 'grabbing';
			},

			// 拖拽中
			onDrag(e) {
				if (!this.isDragging || !this.$refs.chatContainer) return;

				const container = this.$refs.chatContainer;
				// 1. 获取容器实际宽高（固定值，避免实时DOM计算偏差）
				const containerWidth = container.offsetWidth;
				const containerHeight = container.offsetHeight;
				// 2. 获取窗口实时宽高（适配窗口缩放）
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;

				// 3. 计算目标位置（鼠标位置 - 初始偏移量）
				let targetX = e.clientX - this.dragOffsetX;
				let targetY = e.clientY - this.dragOffsetY;

				// 4. 严格边界限制（确保容器完全在窗口内，不超出任何边）
				// 左边界：最小为 0（容器左边不能超出窗口左边）
				targetX = Math.max(0, targetX);
				// 右边界：最大为「窗口宽 - 容器宽」（容器右边不能超出窗口右边）
				targetX = Math.min(targetX, windowWidth - containerWidth);
				// 上边界：最小为 0（容器上边不能超出窗口上边）
				targetY = Math.max(0, targetY);
				// 下边界：最大为「窗口高 - 容器高」（容器下边不能超出窗口下边）
				targetY = Math.min(targetY, windowHeight - containerHeight);

				// 5. 应用最终位置（更新状态+DOM）
				this.containerPosition.x = targetX;
				this.containerPosition.y = targetY;
				container.style.left = `${targetX}px`;
				container.style.top = `${targetY}px`;
			},

			checkBoundaries() {
				const container = this.$refs.chatContainer;
				if (!container) return;

				const containerWidth = container.offsetWidth;
				const containerHeight = container.offsetHeight;
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;

				// 兜底修正位置（防止窗口缩放导致超出边界）
				let fixedX = this.containerPosition.x;
				let fixedY = this.containerPosition.y;

				fixedX = Math.max(0, Math.min(fixedX, windowWidth - containerWidth));
				fixedY = Math.max(0, Math.min(fixedY, windowHeight - containerHeight));

				// 仅在位置有变化时更新（减少DOM操作）
				if (fixedX !== this.containerPosition.x || fixedY !== this.containerPosition.y) {
					this.containerPosition.x = fixedX;
					this.containerPosition.y = fixedY;
					container.style.left = `${fixedX}px`;
					container.style.top = `${fixedY}px`;
				}
			},
			// 停止拖拽
			stopDrag() {
				if (this.isDragging) {
					this.isDragging = false;
					// 恢复鼠标样式
					this.$refs.chatContainer.style.cursor = 'default';
				}
			},

			// 更新容器位置
			updateContainerPosition() {
				const container = this.$refs.chatContainer;
				if (container) {
					container.style.left = `${this.containerPosition.x}px`;
					container.style.top = `${this.containerPosition.y}px`;
				}
			},
			initContainerPosition() {
				const container = this.$refs.chatContainer;
				if (!container) return;

				// 用 offsetWidth/offsetHeight 获取容器真实宽高（不受定位影响）
				const containerWidth = container.offsetWidth;
				const containerHeight = container.offsetHeight;
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;

				// 计算居中位置（确保不小于0，适配小窗口）
				this.containerPosition.x = Math.max(0, (windowWidth - containerWidth) / 2);
				this.containerPosition.y = Math.max(0, (windowHeight - containerHeight) / 2);

				// 应用初始定位
				container.style.left = `${this.containerPosition.x}px`;
				container.style.top = `${this.containerPosition.y}px`;
			},


			shouldShowTimeline(index) {
				if (index === 0) return true;
				const prevTime = parseInt(this.messages[index - 1].type.Date);
				const currTime = parseInt(this.messages[index].type.Date);
				return (currTime - prevTime) > 5 * 60 * 1000; // 5分钟间隔
			},

			// 格式化时间线
			formatTimeline(ts) {
				const time = new Date(parseInt(ts));
				const now = new Date();

				const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
				const yesterday = new Date(today);
				yesterday.setDate(today.getDate() - 1);
				const dayBefore = new Date(today);
				dayBefore.setDate(today.getDate() - 2);

				if (time >= today) {
					// 今天：时:分
					return `${time.getHours().toString().padStart(2, "0")}:${time.getMinutes().toString().padStart(2, "0")}`;
				} else if (time >= yesterday) {
					return "昨天";
				} else if (time >= dayBefore) {
					return "前天";
				} else if (time.getFullYear() === now.getFullYear()) {
					// 同一年：月-日
					return `${time.getMonth() + 1}-${time.getDate()}`;
				} else {
					// 往前：年-月-日
					return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
				}
			},
			Sdelmsg(index) {
				this.messages.splice(index, 1);
				// 更新本地存储
				Setitem(this.msgmenname, this.messages);
				this.isdel = -1;
				this.isgd = true

				// 保持滚动位置
				// this.scrollToBottom();


			},
			Sdelall() {
				this.messages = [];
				Setitem(this.msgmenname, this.messages);
			},


			deleteMessage(index) {
				this.isdel = index
			},


			townum(size) {
				let kbSize = size / 1024;
				if (kbSize >= 1024) {
					return `${(kbSize / 1024).toFixed(2)} MB`;
				} else {
					return `${kbSize.toFixed(2)} KB`;
				}
			},

			scrollToBottom() {
				this.$nextTick(() => {
					const chatMessagesDom = this.$refs.chatMessagesRef;
					if (chatMessagesDom) {
						chatMessagesDom.scrollTop = chatMessagesDom.scrollHeight;
					}
				});
			},

			// 2. 触发文件选择器
			triggerFileSelect() {
				this.$refs.fileInputRef.click();
			},

			// 3. 处理文件选择：校验文件大小 + 调用上传接口
			async handleFileSelect(e) {
				const file = e.target.files[0];
				let url = '';
				let name = file?.name || '';
				let size = file?.size || 0;

				if (!file) return;

				// 1. 文件格式校验
				const allowedTypes = [
					'.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp', '.svg', '.ico',
					'.xls', '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm',
					'.pdf', '.dwg', '.dxf', '.gdb', '.mdb',
					'.docx', '.doc', '.wps', '.et', '.dps',
					'.zip', '.rar', '.7z', '.tar', '.gz', '.bz2'
				].map(ext => ext.trim().toLowerCase());
				const fileExtension = file.name.split('.').pop().toLowerCase();
				if (!allowedTypes.includes(`.${fileExtension}`)) {
					this.$toast?.error(`不支持的文件格式`);
					// 关键：校验失败后重置输入框，避免同一文件无法再次选择
					this.$refs.fileInputRef.value = '';
					return false;
				}

				// 2. 文件大小校验
				const maxSizeMB = ['.zip', '.rar', '.7z', '.tar', '.gz', '.bz2'].includes(`.${fileExtension}`) ? 50 :
					10;
				if (file.size / 1024 / 1024 >= maxSizeMB) {
					this.showError?.(`文件大小不能超过${maxSizeMB}MB`);
					// 关键：校验失败后重置输入框
					this.$refs.fileInputRef.value = '';
					return false;
				}

				// 3. 文件上传
				try {
					const res = await uploadFile(file); // 传入文件
					url = res.data;
				} catch (err) {
					this.$toast?.error("发送失败");
					// 关键：上传失败后重置输入框
					this.$refs.fileInputRef.value = '';
					return false;
				}

				// 4. 构造消息并发送
				const message = {
					url,
					name,
					size
				};
				const ty = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.webp', '.svg', '.ico']
					.map(ext => ext.trim().toLowerCase())
					.includes(`.${fileExtension}`) ? 'image' : 'file';
				await this.sendCurrentContent(message, ty);

				// 🌟 核心修改：发送成功后重置输入框 value，允许同一文件连续选择
				this.$refs.fileInputRef.value = '';
			},

			// 发送消息
			async sendCurrentContent(message, ty) {
				if (ty === 'text') {
					message = message.trim()
				}
				const text = message;
				if (!text) return;
				const zStype = {
					type: ty,
					name: this.target.myname || '未知',
					Date: new Date().getTime(),
					toname: this.target.toname || '未知',
				}
				const listStype = {
					type: ty,
					toname: this.target.myname || '未知',
					Date: new Date().getTime(),
					name: this.target.toname || '未知',
				}


				// 构造文本消息体
				const textMsg = {
					sendUser: this.sendUser,
					toUser: this.toUser,
					msg: JSON.stringify(text),
					type: JSON.stringify(zStype),
				};

				this.ws.send(textMsg)
				const list = {
					sendUser: this.sendUser,
					toUser: this.toUser,
					msg: text,
					type: listStype,
					unread: false
				};
				this.messages.push(list)
				await Setitem(this.msgmenname, this.messages)
				let listname = `${this.sendUser}_list`
				let listmsgs = await Getitem(listname) || [];
				listmsgs = listmsgs.filter(res => res.toUser !== this.toUser);
				listmsgs.unshift(list);
				await Setitem(listname, listmsgs)
				setTimeout(() => {
					this.$store.commit("setnewchat", textMsg)
				}, 200)

				// // 清空输入框 + 滚动到底部
				this.inputMessage = '';
				this.scrollToBottom();
			},



			// 6. 图片预览
			previewImage(url) {
				this.previewImageUrl = url;
			},

			// 7. 关闭图片预览
			closePreview() {
				this.previewImageUrl = '';
			},

			// 8. 文件下载
			downloadFile(fileUrl, fileName) {

				const aTag = document.createElement('a');
				aTag.href = fileUrl;
				aTag.download = fileName; // 文件名
				aTag.target = '_blank'; // 新增这行
				document.body.appendChild(aTag);
				aTag.click();
				document.body.removeChild(aTag);

			},

			// 原有方法：格式化文件大小
			formatFileSize(bytes) {
				if (bytes < 1024) return `
						$ {
							bytes
						}
						B`;
				else if (bytes < 1048576) return `
						$ {
							(bytes / 1024).toFixed(1)
						}
						KB`;
				else return `
						$ {
							(bytes / 1048576).toFixed(1)
						}
						MB`;
			},

			// 原有方法：表情插入
			jionbq(item) {
				this.inputMessage += item;
				this.isbq = false;
			},

			// 原有方法：关闭聊天窗口
			runclose() {
				this.$emit('close');
			},

			// 原有方法：切换到文本输入
			switchToText() {
				this.activePanel = null;
				this.isRecording = false;
			},

			// 以下为原有方法（未修改，保持兼容）
			getHistory(contactId) {
				const {
					proxy
				} = getCurrentInstance();
				return messageHandler?.getMessageHistory(contactId, proxy.userId) || [];
			},
			markMessagesAsRead(contactId) {
				messageHandler?.markAsRead(contactId);
			},
			openPanel(panelType) {
				if (panelType === 'image') this.$refs.fileInputRef.click();
				else if (panelType === 'file') this.$refs.fileInputRef.click();
				else if (panelType === 'audio') this.toggleRecording();
			},
			togglePanel(panelType) {
				this.activePanel = this.activePanel === panelType ? null : panelType;
			},
			toggleRecording() {
				if (this.isRecording) this.stopRecording();
				else this.startRecording();
			},
			startRecording() {
				this.isRecording = true;
				setTimeout(() => {
					if (this.isRecording) this.recordedAudio = 'audio_sample.mp3';
				}, 3000);
			},
			stopRecording() {
				this.isRecording = false;
				if (this.recordedAudio) this.sendCurrentContent();
			},
			async oldmsg() {
				this.ws.line
				// console.log('传过来的', this.target);
				this.sendUser = `${this.myclass}_${this.target.myid}`
				this.toUser = `${this.target.toclass}_${this.target.toid}`
				this.msgmenname =
					`${this.myclass}_${this.target.myid}_${this.target.toclass}_${this.target.toid}`
				let s = await Getitem(this.msgmenname) || []
				if (s.msg !== '') {
					this.messages = s
				}
			},


		},
		watch: {
			'$store.state.otherline': {
				handler: function(newVal, oldVal) {
					this.isOnline = newVal
				}
			},
			'$store.state.newchat': {
				deep: true,
				handler: function(newVal, oldVal) {
					if (newVal && newVal.toUser === this.toUser) {
						this.oldmsg()
					}
				}
			},

			target: {
				handler() {
					this.$store.commit("setonline", "离线");
				}
			},
			messages: {
				deep: true,
				handler() {
					if (!this.isgd) {
						this.scrollToBottom(); // 消息有变化滚动到底部
					}
					this.isgd = false
				}
			},

			'$store.state.msgs': {
				deep: true,
				handler(newVal) {
					if (newVal && this.msgmenname) {
						if (newVal.sendUser == this.msgmenname) {
							this.messages = Getitem(this.msgmenname) || [];
							this.$nextTick(() => this.scrollToBottom());
							// this.$store.commit('setnewchat', false); // 重置标志位
						}
					}
				},
				immediate: true
			}
		},

		async mounted() {
			// 等待DOM渲染完成
			this.$nextTick(() => {
				this.scrollToBottom();
				this.initContainerPosition();
			});
			// const container = this.$refs.chatContainer;
			// const containerRect = container.getBoundingClientRect();
			// this.containerPosition.x = (window.innerWidth - containerRect.width) / 2;
			// this.containerPosition.y = (window.innerHeight - containerRect.height) / 2;
			// this.updateContainerPosition();
			// sendCurrentContent(message, ty)
			window.addEventListener('resize', this.checkBoundaries);
		},
		async created() {
			this.ws = this.$store.state.mews
			let toUser = `${this.target.toclass}_${this.target.toid}`
			this.$store.commit('setSwindow', toUser)
			this.oldmsg()


		},
		beforeDestroy() {
			this.$store.commit('setSwindow', '')
			this.$store.commit('setonline', '离线')
			window.removeEventListener('resize', this.checkBoundaries);
		}
	};
</script>

<style scoped>
	/* 基础动画定义 */
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(5px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes pulse {
		0% {
			transform: scale(1);
		}

		50% {
			transform: scale(1.05);
		}

		100% {
			transform: scale(1);
		}
	}

	/* 聊天容器 */
	.chat-container {
		display: flex;
		flex-direction: column;
		height: 85vh;
		width: 50vw;
		background: #000;
		/* margin: 20px auto; */
		border: 1px solid #e0e0e0;
		overflow: hidden;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		position: relative;
	}

	/* 头部样式 */
	.chat-header {
		height: 5vh;
		display: flex;
		align-items: center;
		padding: 12px 15px;
		background-color: #f8f9fa;
		border-bottom: 1px solid #e0e0e0;
		text-align: left;

		user-select: none;
		-webkit-user-select: none;
		/* Safari浏览器兼容 */
		-moz-user-select: none;
		/* Firefox浏览器兼容 */
		-ms-user-select: none;
		/* IE/Edge浏览器兼容 */

		/* 其他现有样式保持不变 */
		cursor: move;
		/* 显示移动光标，提升用户体验 */
	}

	.avatar-container {
		position: relative;
		margin-right: 12px;
	}

	.header-avatar {
		width: 48px;
		height: 48px;
		border-radius: 50%;
	}

	.online-indicator {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: #ccc;
		border: 2px solid white;
	}

	.online-indicator.online {
		background-color: #4cd964;
	}

	.user-info {
		flex: 1;
	}

	.user-name {
		margin: 0 0 4px 0;
		font-size: 16px;
		font-weight: 600;
	}

	.online-status {
		margin: 0;
		font-size: 12px;
		color: #666;
	}

	/* 消息区域：添加滚动过渡 */
	.chat-messages {
		/* height: 40vh; */
		flex: 1;
		padding: 15px 10px;
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: #ccc #f5f5f5;
		background-color: #f5f5f5;
		scroll-behavior: smooth;
		scrollbar-width: none;
		-ms-overflow-style: none;

	}

	/* 滚动条美化（仅Chrome/Safari） */
	.chat-messages::-webkit-scrollbar {
		width: 6px;
	}

	.chat-messages::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background-color: #ccc;
	}

	/* 消息气泡样式 */
	.message {
		display: flex;
		margin-bottom: 15px;
		max-width: 75%;
		animation: fadeIn 0.3s ease forwards;
	}




	.message.left {
		align-self: flex-start;
		margin-right: auto;
		padding-left: 5px;
	}

	.message.right {
		flex-direction: row-reverse;
		margin-left: auto;
		padding-right: 5px;
	}

	.avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		margin: 0 8px;
		flex-shrink: 0;
	}

	.avatar1 {
		width: 25px;
		height: 25px;
		/* border-radius: 50%; */
		padding-top: -2px;
		margin: 0 8px;
		flex-shrink: 0;
		border: 1px solid #ccc;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #ccc;
		border-radius: 3px;
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
		cursor: pointer;

	}

	.avatar1:hover {
		background-color: red;
		color: white;
		box-shadow: none;
	}

	.del-msg {
		font-size: 20px;
	}

	.content {
		max-width: calc(100% - 52px);
	}

	/* 文本气泡 */
	.bubble {
		padding: 10px 15px;
		border-radius: 18px;
		position: relative;
		word-break: break-word;
		font-size: 13px !important;
	}

	.message.left .bubble {
		background-color: white;
		border-top-left-radius: 4px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	}

	.message.right .bubble {
		background-color: #9eea6a;
		border-top-right-radius: 4px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	}

	/* 无气泡样式（图片/文件） */
	.message.no-bubble .content {
		display: flex;
		align-items: center;
	}

	/* 图片消息 */
	.message-image {
		max-width: 200px;
		max-height: 200px;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
		transition: transform 0.2s ease;
		cursor: pointer;
	}

	.message-image:hover {
		transform: scale(1.02);
	}

	/* 文件消息 */
	.file-item {
		display: flex;
		align-items: flex-start;
		/* 关键：子元素顶部对齐，避免换行后内容错位 */
		gap: 10px;
		min-width: 200px;
		width: 100%;
		/* 可选：让容器适应父级宽度，避免过宽 */
		max-width: 100%;
		/* 限制容器最大宽度，防止超出父级 */
		cursor: pointer;
		transition: background-color 0.2s ease;
		border-radius: 3px;
		border: 1px solid #e0e0e0;
		padding: 10px;
		background-color: white;
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

		/* 1. 允许 flex 子元素换行（核心） */
		flex-wrap: wrap;
		/* 2. 控制换行后子元素的对齐方式（可选，按需调整） */
		align-content: flex-start;
	}

	/* 3. 确保内部文本内容超出时自动换行（关键） */
	.file-item>* {
		/* 选中 .file-item 下所有直接子元素 */
		white-space: normal;
		/* 取消“不换行”限制（默认是 normal，但若子元素有设置 nowrap 需覆盖） */
		word-wrap: break-word;
		/* 允许长单词/URL 换行 */
		word-break: break-all;
		/* 即使单词未到边界，也可强制换行（适配中英文混合场景） */
		flex: 1;
		/* 可选：让文本子元素占满剩余宽度，避免内容过窄就换行 */
		min-width: 0;
		/* 修复 flex 子元素文本溢出问题（关键兼容点） */
	}

	.file-item:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}

	.file-info {
		flex: 1;
		text-align: left;
	}

	.file-name {
		font-weight: 500;
		margin-bottom: 2px;
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.file-size {
		font-size: 12px !important;
		color: #666 !important;
	}

	.file-download-icon {
		font-size: 14px;
		color: #666;
		margin-left: 5px;
	}

	/* 输入区域 */
	.input-area {
		/* 原height: 30vh 改为固定像素，避免屏幕比例影响 */
		height: 180px;
		/* 可根据需求调整，建议180-220px */
		padding: 10px 15px;
		border-top: 1px solid #e0e0e0;
		background-color: white;
		position: relative;
		/* 新增：作为发送按钮的定位容器（关键） */
	}

	.function-buttons {
		display: flex;
		gap: 8px;
		margin-bottom: 10px;
		position: relative;
		height: 36px;
		/* 固定高度，功能按钮区不动态变化 */
	}

	.alldel {
		/* 原绝对定位改为flex布局，靠右显示 */
		position: static;
		/* 清除绝对定位 */
		margin-left: auto;
		/* 自动推到右侧，不挤压其他按钮 */
		display: flex;
		align-items: center;
		height: 100%;
		/* 与功能区高度一致，垂直居中 */
	}

	/* 调整Element UI按钮大小，适配功能区 */
	.alldel .el-button--mini {
		padding: 4px 8px;
		/* 缩小按钮内边距，避免过高 */
		font-size: 12px;
	}

	.Simg,
	.Simg1 {
		height: 25px;
		width: 25px;
		padding: 5px;
		cursor: pointer;
		border-radius: 4px;
	}

	.Simg:hover,
	.Simg1:hover {
		background-color: #e0e0e0;
	}

	.hidden-file-input {
		display: none;
	}

	.text-input-container {
		display: flex;
		gap: 10px;
	}

	.text-input {
		/* 1. 固定高度，替代原22vh（消除屏幕比例差异） */
		height: 110px;
		/* 配合input-area总高180px，预留按钮和功能区空间 */
		width: 100%;
		border: 1px solid #e0e0e0;
		padding: 10px 15px;
		resize: none;
		/* 禁止用户拉伸，避免尺寸失控 */
		outline: none;
		font-size: 15px;
		/* 2. 核心：统一盒模型，padding/border不影响宽高计算 */
		box-sizing: border-box;
		/* 3. 清除浏览器默认样式 */
		margin: 0;
		line-height: 1.5;
		/* 统一行高，避免文本排版差异 */
	}

	.text-input:focus {
		border-color: #42b983;
	}

	/* 发送按钮 */
	.send-btn {
		/* 1. 父容器改为.input-area（需确保.input-area有position: relative） */
		position: absolute;
		bottom: 40px;
		right: 25px;
		width: 80px;
		height: 40px;
		border-radius: 5px;
		border: none;
		background-color: #42b983;
		color: white;
		cursor: pointer;
		transition: all 0.2s ease;
		/* 2. 防止按钮被其他元素遮挡 */
		z-index: 10;
	}

	.send-btn:disabled {
		background-color: #ccc;
		cursor: not-allowed;
	}

	.send-btn:hover:not(:disabled) {
		background-color: #3aa871;
		transform: translateY(-1px);
	}

	.send-btn:active:not(:disabled) {
		transform: translateY(1px);
	}

	/* 表情面板 */
	.biaoqing {
		width: 25vw;
		height: 25vh;
		position: absolute;
		bottom: 32vh;
		left: 2vw;
		z-index: 600;
		background-color: white;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
		border-radius: 15px;
		font-size: 20px;
		padding: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: start;
		gap: 11px;
		overflow-y: auto;
		scrollbar-width: none;
		cursor: pointer;
		padding-left: 15px;
	}

	.biaoqing::-webkit-scrollbar {
		display: none;
	}

	/* 关闭按钮 */
	.close {
		font-size: 35px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 5px;
		right: 15px;
		color: red;
		cursor: pointer;
		font-weight: bold;
		z-index: 700;
		/* 确保在表情面板上方 */
	}

	.close:hover {
		color: #409EFF !important;
	}

	/* 图片预览弹窗 */
	.image-preview {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.image-preview img {
		max-width: 90%;
		max-height: 90%;
		object-fit: contain;
		border-radius: 4px;
	}

	/* 录音相关样式（未修改，保持兼容） */
	.func-btn {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border: none;
		background-color: #f0f0f0;
		font-size: 16px;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.func-btn:hover {
		background-color: #e0e0e0;
		transform: translateY(-1px);
	}

	.func-btn.active {
		background-color: #42b983;
		color: white;
	}

	.func-btn.recording {
		background-color: #ff4444;
		color: white;
		animation: pulse 1.5s infinite;
	}

	.audio-player audio {
		width: 200px;
		height: 36px;
		border-radius: 18px;
		overflow: hidden;
	}

	.emotion {
		font-size: 32px;
		padding: 5px;
	}

	.panel {
		flex: 1;
		padding: 10px;
		border: 1px solid #e0e0e0;
		border-radius: 20px;
		min-height: 40px;
		animation: fadeIn 0.2s ease forwards;
	}

	.emotion-grid {
		display: grid;
		grid-template-columns: repeat(8, 1fr);
		gap: 8px;
		width: 100%;
	}

	.emotion-item {
		font-size: 24px;
		text-align: center;
		cursor: pointer;
		border-radius: 8px;
		transition: all 0.2s ease;
		padding: 4px 0;
	}

	.emotion-item:hover {
		background-color: #f0f0f0;
		transform: scale(1.1);
	}

	.xiang {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
		flex-shrink: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid rgb(121, 187, 255);
		background-color: rgb(51, 126, 204);
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
		color: #e0e0e0;
		position: relative;
	}

	.xiang1 {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 10px;
		flex-shrink: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid rgb(250, 182, 182);
		background-color: #F56C6C;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
		color: #e0e0e0;
		position: relative;
	}

	.xiangs {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		margin-right: 10px;
		flex-shrink: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid rgb(250, 182, 182);
		background-color: #e6f5dd;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
		color: #141414;
		position: relative;
		font-size: 25px;
		color: red;
		font-weight: 900;
	}

	.timeline {
		text-align: center;
		color: #888;
		font-size: 12px;
		margin: 10px 0;
	}

	.announcement-card {
		min-width: 280px;
		max-width: 400px;
		background: linear-gradient(135deg, #2979ff 0%, #94bcff 100%);
		border: 1px solid #2979ff;
		border-radius: 5px;
		padding: 0;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		cursor: pointer;
		transition: all 0.3s ease;
		overflow: hidden;
		color: #fff;
	}

	.announcement-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
		border-color: #2979ff;
	}

	.announcement-header {
		display: flex;
		align-items: center;
		padding: 16px;
		background: linear-gradient(135deg, #2979ff 0%, #6a74ff 100%);
		color: #fff;
		font-weight: 600;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.announcement-icon {
		font-size: 20px;
		margin-right: 8px;

		span {
			font-size: 14px;
		}
	}

	.announcement-title {
		flex: 1;
		font-size: 14px;
		font-weight: bold;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.announcement-arrow {
		font-size: 12px;
		color: #ffffff;
		transition: transform 0.3s ease;
	}

	.announcement-content {
		max-height: 0;
		overflow: hidden;
		transition: max-height 0.4s ease;
		background: white;
	}

	.announcement-content.expanded {
		max-height: 200px;


	}

	.announcement-text {
		padding: 16px;
		font-size: 13px;
		line-height: 1.5;
		color: #5a5a5a;
		background: white;
		max-height: 120px;
		border-bottom: 1px solid #f0f0f0;
		word-wrap: break-word;
		white-space: pre-wrap;
		overflow-y: auto;
		scrollbar-width: none;
		text-align: left;

	}

	.announcement-time {
		padding: 8px 16px;
		font-size: 11px;
		color: #8d8d8d;
		background: #fafafa;
		text-align: right;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.announcement-card {
			min-width: 240px;
			max-width: 320px;
		}

		.announcement-header {
			padding: 12px;
		}

		.announcement-text {
			padding: 12px;
			font-size: 12px;
		}
	}

	/* 为公告消息调整布局 */
	.content.public {
		max-width: calc(100% - 52px);
	}

	/* 确保公告卡片在左右布局中的显示 */
	.message.left .announcement-card {
		margin-right: auto;
	}

	.message.right .announcement-card {
		margin-left: auto;
	}
</style>